var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconVisavale = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlSpace: "preserve",
  id: "Layer_1",
  x: 0,
  y: 0,
  style: {
    enableBackground: "new 0 0 309.9 158.5"
  },
  viewBox: "0 0 309.9 158.5",
  ref: svgRef
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#2d2729}.st1{fill:none;stroke:#fff;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.st2{fill:#fff}.st3{stroke-width:2;stroke-linecap:round;stroke-linejoin:round}.st3,.st4,.st5{fill:none;stroke:#000}.st4{stroke-width:1.5;stroke-miterlimit:10}.st5{stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:7.5407,7.5407}.st6{fill:#191a1a}.st7{fill:#9d9d9d}.st8{stroke:#000;stroke-miterlimit:10}.st9{fill:#f4f4f4}.st10,.st11{stroke-miterlimit:10}.st10{stroke:#000;stroke-width:1.5}.st11{fill:none;stroke:#070707}")), /*#__PURE__*/React.createElement("path", {
  d: "M50.2 147.7h193.1c2.8 0 5.1-2.3 5.1-5.1V16.1c0-2.8-2.3-5.1-5.1-5.1H50.2c-2.8 0-5.1 2.3-5.1 5.1v126.5c0 2.8 2.3 5.1 5.1 5.1z",
  style: {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M139.3 62c-3.3-.1-5.9-2.7-6-6-.2-20.7-17.1-37.3-37.8-37.1S58.2 36.1 58.4 56.8V131c0 3.3 2.7 6 6 6h74.2c20.7.2 37.6-16.4 37.8-37.1S160 62.2 139.3 62z",
  style: {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#0f0f08"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M127 99c-.2 2.1-.8 2.6-2.9 2.6h-16v1.3c0 4.2 2.4 5.9 8.2 5.9 2.5 0 5-.3 7.5-.9 1.8-.5 2.4 0 2.4 2v.7c0 1.9-.4 2.3-2.4 2.8-2.4.6-4.9 1-7.5.9-9.6 0-14.1-3.6-14.1-12.3v-5c0-8.3 4.2-12.4 12.8-12.4 8 0 12.2 4.1 12.2 11.9-.1.9-.1 1.7-.2 2.5zM83.2 84.6c-2.4 0-5.6.4-7.3 1.1v-9.6c0-2.1-.5-2.6-2.6-2.6h-.7c-2.1 0-2.6.5-2.6 2.6V102c0 8.2 4.9 12.3 13.1 12.3 8.8 0 13.1-4 13.1-12.3v-4.9c.1-8.3-5-12.5-13-12.5zm7.2 17.4c0 4.8-1.5 6.8-7.2 6.8s-7.3-2.1-7.3-6.8v-5c0-4.8 1.6-6.9 7.2-6.9h.1c5.6 0 7.2 2.1 7.2 6.9v5zm48.5 9.8c0 2.1-.5 2.6-2.6 2.6h-.7c-2.1 0-2.6-.5-2.6-2.6v-16c0-7.4 4.2-11.1 12.5-11.1 8.7 0 12.5 3.7 12.5 11.1v16c0 2.1-.5 2.6-2.6 2.6h-.7c-2.1 0-2.6-.5-2.6-2.6v-16c0-3.9-1.4-5.6-6.5-5.6s-6.6 1.7-6.6 5.6c-.1 0-.1 16-.1 16zm-30.8-15h13.1v-1c0-3.8-2.2-5.7-6.6-5.7s-6.5 1.9-6.5 5.7v1z",
  style: {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff"
  }
}));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconVisavale, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconVisavale.7c36c221.svg";
export { ForwardRef as ReactComponent };